"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _rffWrapper = require("rff-wrapper");

var _GoogleRecaptcha = _interopRequireDefault(require("./components/GoogleRecaptcha/GoogleRecaptcha"));

var _customProps = require("../../utils/customProps");

var _Grid = _interopRequireDefault(require("../Grid/Grid"));

/* eslint-disable no-undef */

/* eslint-disable max-len */
var BlokForm = function BlokForm(_ref) {
  var content = _ref.content,
      submitButton = _ref.submitButton,
      googleRecaptcha = _ref.googleRecaptcha,
      baseUrl = _ref.baseUrl,
      successResponseText = _ref.successResponseText,
      errorResponseText = _ref.errorResponseText,
      method = _ref.method;
  var components = {
    MuiInput: _rffWrapper.MuiInput,
    MuiSelect: _rffWrapper.MuiSelect,
    MuiSubmit: _rffWrapper.MuiSubmit,
    MuiCheckbox: _rffWrapper.MuiCheckbox,
    MuiRadio: _rffWrapper.MuiRadio
  };

  var _useState = (0, _react.useState)({
    successResponse: '',
    errorResponse: '',
    isABot: true
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(values) {
      var queryString, options;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setState({
                successResponse: successResponseText,
                errorResponse: ''
              });
              queryString = Object.keys(values).map(function (key) {
                return "".concat(key, "=").concat(values[key]);
              }).join('&');
              options = {
                method: method,
                headers: {
                  'content-type': 'application/x-www-form-urlencoded'
                },
                data: queryString
              };
              fetch(baseUrl, options).then(function (response) {
                if (response.ok) {
                  setState({
                    successResponse: successResponseText,
                    errorResponse: ''
                  });
                  return state;
                }
              }).catch(function () {
                return setState({
                  successResponse: '',
                  errorResponse: errorResponseText
                });
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_rffWrapper.Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, content.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({}, item, {
      key: index,
      components: components
    }));
  }), googleRecaptcha.length ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_GoogleRecaptcha.default, (0, _extends2.default)({}, googleRecaptcha[0], {
    isABot: state.isABot,
    setIsABot: setState
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: state.isABot ? {
      display: 'none'
    } : null
  }, /*#__PURE__*/_react.default.createElement(_rffWrapper.MuiSubmit, submitButton[0]))) : /*#__PURE__*/_react.default.createElement(_rffWrapper.MuiSubmit, submitButton[0]), state.successResponse && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    "data-testid": "successResponseTestID"
  }, state.successResponse), state.errorResponse && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    color: "error",
    "data-testid": "errorResponseTestID"
  }, state.errorResponse)));
};

var _default = BlokForm;
exports.default = _default;
BlokForm.propTypes = {
  content: function content(props, propName, componentName) {
    var components = ['MuiInput', 'MuiSelect', 'MuiCheckbox', 'MuiRadio'];
    return (0, _customProps.nestedComponentsProps)(props, propName, componentName, components);
  },
  submitButton: function submitButton(props, propName, componentName) {
    var components = ['MuiSubmit'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },
  googleRecaptcha: function googleRecaptcha(props, propName, componentName) {
    var components = ['GoogleRecaptcha'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },
  method: function method(props, propName, componentName) {
    var validProps = ['POST', 'GET'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },
  baseUrl: _propTypes.default.string.isRequired,
  successResponseText: _propTypes.default.string.isRequired,
  errorResponseText: _propTypes.default.string.isRequired
};
BlokForm.defaultProps = {
  method: 'POST',
  content: [],
  submitButton: [],
  googleRecaptcha: []
};